import { ArrowLeft, KeyRound, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export default function ForgotPasswordPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white px-6 py-10 text-slate-900">
      <div className="mx-auto mb-8 flex w-full max-w-3xl items-center justify-between text-sm text-slate-500">
        <Link
          to="/auth/login"
          className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 shadow-sm transition hover:bg-slate-50"
        >
          <ArrowLeft size={18} />
          Ко входу
        </Link>
        <span className="text-xs uppercase tracking-[0.35em] text-slate-400">TravelStat</span>
      </div>

      <main className="mx-auto flex min-h-[calc(100vh-8rem)] max-w-3xl items-center justify-center">
        <section className="w-full rounded-2xl border border-slate-200 bg-white p-7 shadow-[0_20px_50px_rgba(15,23,42,0.08)]">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600">
            <KeyRound size={28} />
          </div>
          <h1 className="mt-5 text-2xl font-bold text-slate-900">Восстановление пароля</h1>
          <p className="mt-2 text-sm leading-6 text-slate-500">
            Рассылка писем для восстановления пароля пока не подключена.
          </p>

          <div className="mt-6 rounded-2xl border border-indigo-100 bg-indigo-50 px-5 py-4 text-sm leading-6 text-indigo-900">
            <div className="mb-2 flex items-center gap-2 font-semibold">
              <Mail size={18} />
              Обратитесь к администратору
            </div>
            Для восстановления пароля напишите администратору и укажите e-mail вашего аккаунта.
          </div>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/auth/login"
              className="inline-flex flex-1 items-center justify-center rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-800"
            >
              Ко входу
            </Link>
            <Link
              to="/auth/register"
              className="inline-flex flex-1 items-center justify-center rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
            >
              Регистрация
            </Link>
          </div>
        </section>
      </main>
    </div>
  );
}
